import { network } from 'services/network';

import { QueryParams } from 'api/queries/statusChangesTableData.query';

export const ENDPOINT = 'api/bo/getTopStatusChanges';

export const getTopStatusChanges = (params: QueryParams) => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
